import { getCalendarUnreadCounts, getNotificationUnreadCounts } from "@endpoints/notification.service";
import { FETCH_NOTIFICATION_COUNTS, UPDATE_NOTIFICATION_COUNTS } from "./action.types";

export const fetchNotificationCounts = () => {
    return async (dispatch, getState) => {
        try {
            const response1 = await getCalendarUnreadCounts();
            const response2 = await getNotificationUnreadCounts();
            const finalUpdate = {
                notification: response2?.data?.count,
                meeting: {
                    count: response1?.data?.count,
                    generalUnreadCount: response1?.data?.generalUnreadCount,
                    specificUnreadCount: response1?.data?.specificUnreadCount
                }
            }
            dispatch({
                type: FETCH_NOTIFICATION_COUNTS,
                payload: finalUpdate
            })
        } catch (error) {

        }
    };
};

export const updateNotificationCounts = (payload) => {
    return {
        type: UPDATE_NOTIFICATION_COUNTS,
        payload
    }
};